/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verify_Ticket_ValidInputs */

const en_verify_ticket_valid = /** @type {(inputs: Verify_Ticket_ValidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valid Ticket`)
};

const es_verify_ticket_valid = /** @type {(inputs: Verify_Ticket_ValidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticket Válido`)
};

const fr_verify_ticket_valid = /** @type {(inputs: Verify_Ticket_ValidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticket valide`)
};

const de_verify_ticket_valid = /** @type {(inputs: Verify_Ticket_ValidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gültiges Ticket`)
};

const id_verify_ticket_valid = /** @type {(inputs: Verify_Ticket_ValidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiket Valid`)
};

/** @type {(inputs: Verify_Ticket_ValidInputs) => LocalizedString} */
const ja_verify_ticket_valid = en_verify_ticket_valid;

/** @type {(inputs: Verify_Ticket_ValidInputs) => LocalizedString} */
const zh_verify_ticket_valid = en_verify_ticket_valid;

/** @type {(inputs: Verify_Ticket_ValidInputs) => LocalizedString} */
const ar_verify_ticket_valid = en_verify_ticket_valid;

/** @type {(inputs: Verify_Ticket_ValidInputs) => LocalizedString} */
const it_verify_ticket_valid = en_verify_ticket_valid;

/** @type {(inputs: Verify_Ticket_ValidInputs) => LocalizedString} */
const ru_verify_ticket_valid = en_verify_ticket_valid;

/** @type {(inputs: Verify_Ticket_ValidInputs) => LocalizedString} */
const pt_verify_ticket_valid = en_verify_ticket_valid;

/** @type {(inputs: Verify_Ticket_ValidInputs) => LocalizedString} */
const ko_verify_ticket_valid = en_verify_ticket_valid;

/**
* | output |
* | --- |
* | "Valid Ticket" |
*
* @param {Verify_Ticket_ValidInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const verify_ticket_valid = /** @type {((inputs?: Verify_Ticket_ValidInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verify_Ticket_ValidInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_verify_ticket_valid(inputs)
	if (locale === "es") return es_verify_ticket_valid(inputs)
	if (locale === "fr") return fr_verify_ticket_valid(inputs)
	if (locale === "de") return de_verify_ticket_valid(inputs)
	if (locale === "ja") return ja_verify_ticket_valid(inputs)
	if (locale === "zh") return zh_verify_ticket_valid(inputs)
	if (locale === "ar") return ar_verify_ticket_valid(inputs)
	if (locale === "id") return id_verify_ticket_valid(inputs)
	if (locale === "it") return it_verify_ticket_valid(inputs)
	if (locale === "ru") return ru_verify_ticket_valid(inputs)
	if (locale === "pt") return pt_verify_ticket_valid(inputs)
	return ko_verify_ticket_valid(inputs)
});